import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_BASE_URL } from '../../config';
import Pagination from '../Pagination/Paginations';
import EntriesSelector from '../Pagination/EntriesSelector';
import DownloadButtons from '../DownloadButtons/DownloadButtons';


const JobListing = () => {
  const [jobs, setJobs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = () => {
    axios.get(`${API_BASE_URL}/jobs`)
      .then(res => setJobs(res.data))
      .catch(err => toast.error('Failed to fetch jobs'));
  };

  const today = new Date().toISOString().slice(0, 10); 

const filteredJobs = jobs
  .filter(job =>
    job.job_title.toLowerCase().includes(searchTerm.toLowerCase()) &&
    job.date_of_closing && job.date_of_closing >= today
  );


  const totalPages = Math.ceil(filteredJobs.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentJobs = filteredJobs.slice(indexOfFirst, indexOfLast);

  return (
    <div className="section-body">
      <div className="container-fluid">
        <ToastContainer position="bottom-right" autoClose={3000} transition={Slide} />

      <div className="p-3 border-bottom bg-light">
  <div className="d-flex justify-content-between align-items-center">
    
    {/* Left group: Download + Entries */}
    <div className="d-flex align-items-center gap-3">
      <DownloadButtons data={filteredJobs} filename="jobs_report" />
      <EntriesSelector
        entriesPerPage={entriesPerPage}
        setEntriesPerPage={setEntriesPerPage}
        setCurrentPage={setCurrentPage}
      />
    </div>

    {/* Right: Search box */}
    <div style={{ width: '250px' }}>
      <input
        type="text"
        placeholder="Search by title..."
        value={searchTerm}
        onChange={e => {
          setSearchTerm(e.target.value);
          setCurrentPage(1);
        }}
        className="form-control"
      />
    </div>
  </div>
</div>



        <div className="card">
          <div className="card-header">
            <h5 className="card-title">Job Listings</h5>
          </div>
          <div className="card-body table-responsive">
            <table className="table table-bordered">
              <thead className="table-light">
                <tr>
                  <th className="fw-bold fs-6">Job ID</th>
                  <th className="fw-bold fs-6">Title</th>
                  <th className="fw-bold fs-6">Company</th>
                  <th className="fw-bold fs-6">Status</th>
                  <th className="fw-bold fs-6">Created</th>
                  <th className="fw-bold fs-6">Date of Closing</th>
                  <th className="fw-bold fs-6">No. of Vacancy</th>
                </tr>
              </thead>
              <tbody>
                {currentJobs.map((job, index) => (
                  <tr key={index}>
                    <td>{job.job_id}</td>
                    <td>{job.job_title}</td>
                    <td>{job.company_name}</td>
                    <td>{job.status === 1 ? 'Active' : 'Inactive'}</td>
                    <td>{job.created_at}</td>
                    <td>{job.date_of_closing}</td>
                    <td>{job.job_vacancy}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {currentJobs.length === 0 && <p>No jobs found.</p>}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
</div>
  );
};

export default JobListing;